import { AbstractIconComponent } from './abstract.icon'
import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'drr-map-pin',
  templateUrl: './map-pin.component.html',
  imports: [CommonModule],
})
export class DrrMapPinComponent extends AbstractIconComponent {
  @Input() active = false
  @Input() name = 'drr-aaa-pin'
}
